import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  show: false,
  message: "",
};

const globalLoaderSlice = createSlice({
  name: "globalLoader",
  initialState,
  reducers: {
    showLoader: (state, action) => {
      state.show = true;
      state.message = action.payload || "";
    },
    hideLoader: (state) => {
      state.show = false;
      state.message = "";
    },
  },
});

export const { showLoader, hideLoader } = globalLoaderSlice.actions;
export default globalLoaderSlice.reducer;
